<div class="popup-global-layout width-700 p-4">
  <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="cancelSetDefaultPayment()">close</mat-icon></div>
  <div class="global-title">Set Default Payment Method</div>
  <div class="global-yellow-bar"></div>
  <div class="global-text">To proceed with redeem and pay, please ensure that you have set your default payment method.</div>
  <div class="global-button-format">
    <button (click)="cancelSetDefaultPayment()" class="dw-secondary-button icon-left"><mat-icon class="blue">keyboard_arrow_left</mat-icon>Cancel</button>
    <button (click)="gotoSetDefaultPayment($event)" class="dw-primary-button icon-right">Set My Default Payment<mat-icon class="black">keyboard_arrow_right</mat-icon></button>
  </div>
</div>